export const getNavigationValues = (pathname) => {
  switch (pathname) {
    case '/api/auth/signin':
      return {
        currentScreen: 'login',
        showHeaderBar: true,
        showThemeIcon: true,
        showCloseIcon: false,
        showVariantHeaderBar: false,
        showFooterBar: false
      }
    case '/api/auth/signin/pincode':
      return {
        currentScreen: 'validation',
        showHeaderBar: true,
        showThemeIcon: true,
        showCloseIcon: true,
        showVariantHeaderBar: false,
        showFooterBar: false
      }
    case '/':
      return {
        currentScreen: 'main',
        showHeaderBar: true,
        showThemeIcon: true,
        showCloseIcon: true,
        showVariantHeaderBar: false,
        showFooterBar: true
      }
    case '/orders':
      return {
        currentScreen: 'ordersList',
        showHeaderBar: true,
        showThemeIcon: true,
        showCloseIcon: true,
        showVariantHeaderBar: false,
        showFooterBar: true
      }
    case '/delivery':
      return {
        currentScreen: 'deliverOrder',
        showHeaderBar: false,
        showThemeIcon: false,
        showCloseIcon: false,
        showVariantHeaderBar: true,
        showFooterBar: false
      }
    default:
      return {
        currentScreen: 'notFound',
        showHeaderBar: false,
        showThemeIcon: false,
        showCloseIcon: false,
        showVariantHeaderBar: false,
        showFooterBar: false
      }
  }
}
